export interface UserMetricsSchema {
    id?: number;
    user_id: number;
    portfolio_value?: number;
    creator_value?: number;
    creator_rewards?: number;
    follow_count?: number;
    follower_count?: number;
    creator_likes_count?: number;
    updated_at?: number;
    coin_portfolio_value?: number;
    coin_creator_value?: number;
    coin_creator_rewards?: number;
}

export interface UserMetrics {
    userId: number;
    portfolioValue?: number;
    creatorValue?: number;
    creatorRewards?: number;
    followCount?: number;
    followerCount?: number;
    creatorLikesCount?: number;
    updatedAt?: number;
    coinPortfolioValue?: number;
    coinCreatorValue?: number;
    coinCreatorRewards?: number;
}

export const defaultUserMetrics: UserMetrics = {
    userId: 0,
    portfolioValue: 0,
    creatorValue: 0,
    creatorRewards: 0,
    followCount: 0,
    followerCount: 0,
    creatorLikesCount: 0,
    updatedAt: 0,
    coinPortfolioValue: 0,
    coinCreatorValue: 0,
    coinCreatorRewards: 0,
};

export const getUserMetricsFromSchema = (schema: UserMetricsSchema): UserMetrics => ({
    userId: schema.user_id,
    portfolioValue: schema.portfolio_value,
    creatorValue: schema.creator_value,
    creatorRewards: schema.creator_rewards,
    followCount: schema.follow_count,
    followerCount: schema.follower_count,
    creatorLikesCount: schema.creator_likes_count,
    updatedAt: schema.updated_at,
    coinPortfolioValue: schema.coin_portfolio_value,
    coinCreatorValue: schema.coin_creator_value,
    coinCreatorRewards: schema.coin_creator_rewards,
});

export interface UserMetricsDailySchema {
    user_id: number;
    portfolio_value: number;
    holding_count_eth: number;
    holding_count_coins: number;
    holder_count: number;
    followers_count: number;
    helps_count: number;
    twitter_views: number;
    created_at: number;
}
